import { SortType } from "../SortType";

export interface VoucherEmailerFilters {
  page_no: number;
  search_text?: string;
  limit: number;
  sort_by: string;
  sort_type: SortType;
}

export function parseQueryParamsForVoucherEmailerFilters(
  params: VoucherEmailerFilters | null,
  query_params: URLSearchParams
): VoucherEmailerFilters {
  return {
    page_no: params?.page_no ?? 1,
    search_text: params?.search_text ?? "",
    limit: params?.limit ?? 30,
    sort_by: params?.sort_by ?? "id",
    sort_type: params?.sort_type ?? SortType.DESC,
  };
}
